<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-form
          @submit="onSubmit"
          @reset="onReset"
          class="q-gutter-sm"
          v-if="visibleButtons">
        <q-input
            :dense="$q.screen.lt.md"
            filled
            autofocus
            clearable
            @clear="clearData"
            v-model="customer.title"
            label="عنوان شرکت، شهر، منطقه، نوع فعالیت، عنوان طرف معامله و شماره تماس ..."
        >
          <template v-slot:append>
            <q-btn color="primary" flat round icon="settings">
              <q-popup-proxy>
                <q-card flat>
                  <q-card-section>
                    <div class="q-pa-sm">
                      <q-select
                          v-model="customer.company"
                          :options="companies"
                          option-label="CompName"
                          option-value="CompID"
                          label="شرکت"
                          use-chips
                          multiple
                      />
                      <q-select
                          v-model="customer.state"
                          label="استان"
                          :options="statesOptions"
                          option-label="State_Name"
                          option-value="State_ID"
                          @filter="filterFn"
                          use-chips
                          use-input
                          multiple
                      />
                      <q-select
                          v-model="customer.city"
                          label="شهر"
                          :options="citiesOptions"
                          option-label="City_Name"
                          option-value="City_ID"
                          @filter="filterCityFn"
                          use-chips
                          use-input
                          multiple
                      />
                      <q-select
                          :dense="$q.screen.lt.md"
                          class="q-ma-xs"
                          v-model="customer.zone"
                          input-debounce="0"
                          label="منطقه"
                          :options="zones"
                          use-chips
                          use-input
                          multiple
                          option-label="Zone_Name"
                          option-value="Zone_ID"
                      >
                        <template v-slot:no-option>
                          <q-item>
                            <q-item-section class="text-grey">
                              بدون نتیجه
                            </q-item-section>
                          </q-item>
                        </template>
                      </q-select>

                      <q-select
                          v-model="customer.jobType"
                          label="صنف"
                          :options="customerKindsOptions"
                          option-label="CSKind_Name"
                          option-value="CsKind_ID"
                          @filter="filterKindFn"
                          use-chips
                          use-input
                          multiple
                      />
                      <q-select
                          v-if="$store.state.roles.some(v=>['admin'].includes(v))"
                          v-model="customer.customerSpecIDs"
                          label="ماهیت"
                          :options="customerKindsOptions"
                          option-label="CSKind_Name"
                          option-value="CsKind_ID"
                          @filter="filterKindFn"
                          use-chips
                          use-input
                          multiple
                      />
                      <q-select
                          v-model="customer.tags"
                          label="برچسب"
                          :options="tags"
                          option-label="TagName"
                          option-value="TagName"
                          use-chips
                          use-input
                          multiple
                      />
                      <q-select v-model="grdShowType"
                                :options="grdShowTypeCaptions"
                                v-if="!$q.screen.lt.md"
                                option-value="typeName"
                                option-label="typeCaption"
                                emit-value
                                map-options
                                label="نوع نمایش جدول"
                      />
                    </div>
                    <q-toggle color="red" v-model="isDeboter" label="مشاهده لیست بدهکاران"/>
                    <q-toggle color="red" v-model="isCreditor" label="مشاهده لیست بستانکاران"/>
                    <q-toggle color="red" v-model="isArchived"
                              label="عدم نمایش طرف معامله آرشیو شده"
                    />
                  </q-card-section>
                </q-card>
              </q-popup-proxy>
            </q-btn>
            <q-btn v-if="!$q.screen.lt.md" flat round @click="onSubmit" icon="search" color="primary"/>
          </template>
        </q-input>
        <div class="q-pa-md q-pa-sm justify-start" v-if="$q.screen.lt.md">
          <q-btn label="تایید" type="submit" icon="search" color="primary"/>
          <q-btn label="انصراف" @click="clearData"
                 type="reset" icon="search_off" color="red" flat class="q-ml-sm"/>
        </div>
      </q-form>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from 'vuex';
import EventBus from "@/event-bus";

export default {
  name: "CustomerSearchPanel",
  components: {},
  props: {
    buyList: {
      type: Boolean
    },
    isBuyAndSaleList: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      customer: {
        title: null,
        company: null,
        state: null,
        jobType: null,
        city: null,
        customerSpecIDs: null,
        zone: null,
        tags: null
      },
      isCreditor: false,
      isDeboter: false,
      isArchived: true,
      activeCustomer: false,
      visibleButtons: true,
      companies: [],
      states: [],
      cities: [],
      citiesOptions: [],
      statesOptions: [],
      customerKinds: [],
      zones: [],
      tags:[],
      customerKindsOptions: [],
      grdShowType: {typeName: 'details', typeCaption: 'پیشرفته'},
      grdShowTypeCaptions: [
        {typeName: 'simple', typeCaption: 'ساده'},
        {typeName: 'details', typeCaption: 'پیشرفته'},
      ],
      items: []
    }
  },
  methods: {
    ...mapActions({
    }),
    clearData() {
      EventBus.$emit('invoke-customer-search-result-event', []);
    },
    onSubmit() {
      this.getCustomerByTitle({
        title: this.customer.title,
        company: this.customer.company !== null ? this.customer.company.map(item => item.CompID).join() : null,
        state: this.customer.state !== null ? this.customer.state.map(item => item.State_ID).join() : null,
        city: this.customer.city !== null ? this.customer.city.map(item => item.City_ID).join() : null,
        jobType: this.customer.jobType !== null ? this.customer.jobType.map(item => item.CSKind_ID).join() : null,
        zone: this.customer.zone !== null ? this.customer.zone.map(item => item.Zone_ID).join() : null,
        tags : this.customer.tags!==null ? this.customer.tags.map(item => item.TagName).join() : null,
        customerSpecIDs: this.customer.customerSpecIDs !== null ? this.customer.customerSpecIDs.map(item => item.CSKind_ID).join() : null,
        isDeboter: this.isDeboter,
        isArchived: this.isArchived,
        isBuyList: this.buyList,
        isBuyAndSaleList: this.isBuyAndSaleList
      }).then((data) => {
        if (this.isDeboter) {
          data = data.filter(item => item.RemCredit > 0)
        } else if (this.isCreditor) {
          data = data.filter(item => item.RemCredit < 0)
        }
        this.items = data
        EventBus.$emit('invoke-customer-search-result-event', data);
      });
    },
    onReset() {
      this.customer.title = null;
    },
    ...mapActions({
      getCustomerByTitle: 'Customers/getByTitle',
      getCustomerSearchConstant: 'Customers/getCustomerSearchConstants',
      getCity: 'Customers/getCity'
    }),
    filterFn(val, update) {
      update(() => {
        this.statesOptions = this.states.filter(item => item.State_Name.includes(val))
      })
    },
    filterCityFn(val, update) {
      update(() => {
        this.citiesOptions = this.cities.filter(item => item.City_Name.includes(val))
      })
    },
    filterKindFn(val, update) {
      update(() => {
        this.customerKindsOptions = this.customerKinds.filter(item => item.CSKind_Name.includes(val))
      })
    }
  },
  watch: {
    'grdShowType': function (val) {
      this.$emit('layout-changed', val)
    },
    'customer.state': function (val) {
      if (!val || val.length === 0) {
        this.cities = []
        this.citiesOptions = []
      }else{
        this.getCity(val.map(item => item.State_ID).join()).then((res) => {
          this.cities = res;
          this.citiesOptions = this.cities;
        })
      }
    }
  },
  meta() {
    return {
      title: "جستجو در بانک اطلاعاتی طرف معامله"
    }
  },
  created() {
    this.getCustomerSearchConstant().then((res) => {
      this.companies = eval(res.company);
      this.states = eval(res.customerState);
      this.statesOptions = this.states;
      this.customerKinds = eval(res.customerKind)
      this.customerKindsOptions = this.customerKinds
      this.zones = JSON.parse(res.zones)
      this.tags = JSON.parse(res.customerTags)
    })
  }
}
</script>

<style scoped>

</style>
